/* Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. */

import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CloudRepo } from '../services/workflow.service';

@Component({
  selector: 'middleware-connector-selector',
  templateUrl: './middleware-connector-selector.component.html',
  styleUrls: ['./middleware-connector-selector.component.less'],
  standalone: false,
})
export class MiddlewareConnectorSelectorComponent {
  private _cloudRepos: CloudRepo[] = [];
  @Input() set cloudRepos(value: CloudRepo[]) {
    this._cloudRepos = value;
  }
  get cloudRepos(): CloudRepo[] {
    return this._cloudRepos;
  }

  selectedConnector: CloudRepo;
  repoGlyphs: Record<string, string> = {
    DocuShare: 'xgl-docushare_logo',
    GraphSharePoint: 'xgl-ms_office',
    GraphOneDrive: 'xgl-onedrive',
    GoogleDrive: 'xgl-google_drive',
    Dropbox: 'xgl-dropbox',
    Box: 'xgl-box_logo',
  };

  getRepoGlyph(connector: string): string {
    return this.repoGlyphs[connector];
  }

  constructor(public activeModal: NgbActiveModal) {}
}
